import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { DefaultEntityPresentationApi } from '@backstage/plugin-catalog';
import {
  catalogApiRef,
  defaultEntityPresentation,
  entityPresentationApiRef,
} from '@backstage/plugin-catalog-react';
import { getBrandedEntityIcon } from './brandIcons';

const brandedEntityPresentationApi = ApiBlueprint.make({
  name: 'entity-presentation',
  params: defineParams =>
    defineParams({
      api: entityPresentationApiRef,
      deps: { catalogApiImp: catalogApiRef },
      factory: ({ catalogApiImp }) =>
        DefaultEntityPresentationApi.create({
          catalogApi: catalogApiImp,
          renderer: {
            async: true,
            render: ({ entityRef, entity, context }) => {
              const presentation = defaultEntityPresentation(
                entity ?? entityRef,
                context,
              );

              return {
                snapshot: {
                  ...presentation,
                  Icon:
                    getBrandedEntityIcon({ entityRef, entity }) ??
                    presentation.Icon,
                },
              };
            },
          },
        }),
    }),
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [brandedEntityPresentationApi],
});